import React, { useId } from "react";
import { MARINE_PLATFORMS } from "../../features/fishingIntelligence/marineFishingContext";
import "../../styles/components/MarineFishingPlatform.css";

export default function MarineFishingPlatform({ value, onChange, t, required = true, disabled = false }) {
  const id = useId();
  return <fieldset className="rp-marine-platform" aria-describedby={`${id}-help`} disabled={disabled}>
    <legend>{t("marine_context_heading")} <span>{t(required ? "marine_context_required" : "fishing_today_setting_optional")}</span></legend>
    <div className="rp-marine-platform__choices">
      {MARINE_PLATFORMS.map((platform) => <label key={platform}>
        <input type="radio" name={`${id}-platform`} value={platform} checked={value === platform}
          onChange={() => onChange(platform)} required={required} />
        <span>{t(`marine_context_${platform}`)}</span>
      </label>)}
    </div>
    <p id={`${id}-help`}>{t(required && !value ? "marine_context_choose" : "marine_context_scope")}</p>
  </fieldset>;
}
